//** Import Modules */
import axiosWithAuth from "../../../utils/axiosWithAuth";

export function requestGetRestaurantsList(businessID, category) {
  const categoryQuery = category
    ? `?category=${encodeURIComponent(category)}`
    : "";

  return axiosWithAuth().request({
    method: "get",
    url: `${process.env.REACT_APP_BE_API_URL}/api/restaurant/dish/${businessID}/date_create${categoryQuery}`,
  });
}
